// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"197":"7352a94a0a","218":"59d5594d88"}[chunkId] + ".js";
};